import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { env } from "@beztack/env/ui";
import { queryKeys } from "@/lib/query-keys";

type OrgSettings = {
  currency: string | null;
};

export function useOrgSettings(orgId?: string) {
  return useQuery({
    queryKey: queryKeys.orgSettings.byOrg(orgId),
    enabled: !!orgId,
    queryFn: async (): Promise<OrgSettings> => {
      const response = await fetch(`${env.VITE_API_URL}/api/organization/settings`, {
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch organization settings");
      }
      return response.json() as Promise<OrgSettings>;
    },
  });
}

export function useOrgCurrency(orgId?: string) {
  const { data } = useOrgSettings(orgId);
  return data?.currency ?? "UYU";
}

export function useUpdateOrgCurrency() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ currency }: { currency: string }) => {
      const response = await fetch(`${env.VITE_API_URL}/api/organization/theme`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ currency }),
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error("Failed to update currency");
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.orgSettings.all() });
    },
  });
}
